import { message } from "antd"
import apiClient from "./apiClient"

export const OS_LABEL = {
  windows: "Windows",
  linux: "Linux",
  macos: "macOS",
}

export const osLabel = (device) =>
  OS_LABEL[device?.osPlatform] ||
  device?.osName ||
  device?.sysInfo?.["OS Name"] ||
  "—"

export const hasRustdeskId = (device) => Boolean(String(device?.rustdesk_id || "").trim())

export const sessionStatusOf = (device) => device?.remoteSessionStatus || "idle"

export const rustdeskLaunchUrl = (id) =>
  `rustdesk://connection/new/${encodeURIComponent(String(id || "").trim())}`

export const copyText = async (text, success = "Copied") => {
  const value = String(text || "").trim()
  if (!value) {
    message.warning("Nothing to copy")
    return false
  }
  try {
    await navigator.clipboard.writeText(value)
    message.success(success)
    return true
  } catch (err) {
    message.error("Could not copy")
    return false
  }
}

export const launchRustdesk = (device) => {
  if (!hasRustdeskId(device)) {
    message.warning("This device has not reported a RustDesk ID")
    return
  }
  if (device.rustdesk_password) {
    copyText(device.rustdesk_password, "Password copied. Complete the connection in RustDesk.")
  }
  window.location.href = rustdeskLaunchUrl(device.rustdesk_id)
}

export const queueRemoteAction = async ({
  device,
  action,
  setTaskId,
  setRender,
  updateDeviceTask,
}) => {
  const hostname = device?.hostname
  const rustdeskId = device?.rustdesk_id
  if (!hostname) {
    message.error("Device hostname is missing")
    return null
  }
  if (!rustdeskId) {
    message.warning("This device has not reported a RustDesk ID yet. Sync it first.")
    return null
  }

  const command = `${action}:${rustdeskId}`
  updateDeviceTask?.(hostname, command, { status: "pending" })
  const response = await apiClient(`devices/${hostname}/create-task`, "POST", {
    entityType: "remotesupport",
    hostname,
    name: action,
    command,
  })

  if (response?.status === "Blocked" || response?.type === "error") {
    message.warning(response.message || "Could not start remote access")
    return response
  }

  if (response?.taskId) setTaskId?.(response.taskId)
  setRender?.((pre) => !pre)
  message.success(
    action === "connect"
      ? `Remote access is starting on ${hostname}`
      : `Disconnect queued for ${hostname}`
  )
  return response
}
